"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformToGrowthBookAttributes = void 0;
function transformToGrowthBookAttributes(targetingAttributes) {
    var _a, _b, _c, _d, _e;
    const growthBookAttributes = {};
    if ('anonymousUserId' in targetingAttributes) {
        growthBookAttributes['anonymousUserId'] = targetingAttributes.anonymousUserId.value;
    }
    if ('deviceType' in targetingAttributes) {
        growthBookAttributes['deviceType'] = targetingAttributes.deviceType.value;
    }
    if (targetingAttributes.user) {
        if ('id' in targetingAttributes.user) {
            growthBookAttributes['id'] = (_a = targetingAttributes.user.id) === null || _a === void 0 ? void 0 : _a.value;
        }
        if ('currentRoleType' in targetingAttributes.user) {
            growthBookAttributes['currentRoleType'] = (_b = targetingAttributes.user.currentRoleType) === null || _b === void 0 ? void 0 : _b.value;
        }
        if ('permissions' in targetingAttributes.user) {
            growthBookAttributes['permissions'] = (_c = targetingAttributes.user.permissions) === null || _c === void 0 ? void 0 : _c.value;
        }
        if ('companyId' in targetingAttributes.user) {
            growthBookAttributes['companyId'] = (_d = targetingAttributes.user.companyId) === null || _d === void 0 ? void 0 : _d.value;
        }
        if ('franchise' in targetingAttributes.user) {
            growthBookAttributes['franchise'] = (_e = targetingAttributes.user.franchise) === null || _e === void 0 ? void 0 : _e.value;
        }
    }
    return growthBookAttributes;
}
exports.transformToGrowthBookAttributes = transformToGrowthBookAttributes;
//# sourceMappingURL=index.js.map